import { observer } from "mobx-react";

const Button = ({
  classes,
  disabled,
  onClick,
  text,
}: {
  classes: string;
  disabled: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  text: string;
}) => {
  return (
    <button
      className={`flex justify-center px-2 py-2 items-center text-neutra-200 rounded-md shadow-2xl font-semibold ${classes}`}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="uppercase">{text}</span>
    </button>
  );
};

export default observer(Button);